<script setup>
import { ref, watch } from 'vue';
import { errorsToMessage } from '../../libs/errors';

/*
- modelValue es el valor del campo que estamos monitorizando el error
- error: Es el error devuelto por el servidor

Cuando cambia el valor se limpia el error y cuando desde fuera se
asigna un error, se vuelve a mostrar
*/
const props = defineProps({
  // Puede llegar cualquier tipo de dato en el valor
  // eslint-disable-next-line vue/require-prop-types
  modelValue: { default: null },
  error: { type: [String, Array], default: null },
});

const message = ref(null);

// Cuando cambia el valor quitamos el error
watch(
  () => props.modelValue,
  () => {
    message.value = '';
  },
);

watch(
  () => props.error,
  () => {
    message.value = errorsToMessage(props.error);
  },
);
</script>

<template>
  <!-- eslint-disable vue/no-v-html -->
  <span class="help-block text-danger" v-html="message"></span>
</template>
